import { typography } from '../global/typography';
export const MuiAlertTitle = {
    MuiAlertTitle: {
        styleOverrides: {
            root: Object.assign({ marginTop: 0 }, typography.subtitle1),
        },
    },
};
